module.exports = __webpack_public_path__ + "304d14b441a211c9de0b8694054cf4f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/a/a04.jpg
// module id = 488
// module chunks = 0